import { BaseModel } from '../classes/base-model';

export class Role extends BaseModel {
    Id?: number;
    Name?: string;
    IsActive?: boolean;
}



// WEBPACK FOOTER //
// ./src/app/models/role.ts